export class CompanyBoard {
  name: string;
  companyId: number;
  total: number;
  rateLevel1: number;
  rateLevel2: number;
  rateLevel3: number;
}
